import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchServiceTokens, issueServiceToken, revokeServiceToken, type ServiceTokenScope } from '../../lib/api';
import { queryKeys } from './queryKeys';

export const useServiceTokens = (token: string | null, projectId: string) =>
  useQuery({
    queryKey: queryKeys.serviceTokens.all(projectId),
    queryFn: () => fetchServiceTokens(token as string, projectId),
    enabled: Boolean(token) && projectId.length > 0,
    staleTime: 60_000,
  });

export const useIssueServiceTokenMutation = (token: string | null, projectId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; scope: ServiceTokenScope; expiresAt: string }) =>
      issueServiceToken(token as string, projectId, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.serviceTokens.all(projectId) });
    },
  });
};

export const useRevokeServiceTokenMutation = (token: string | null, projectId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (serviceTokenId: string) => revokeServiceToken(token as string, projectId, serviceTokenId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.serviceTokens.all(projectId) });
    },
  });
};
